import parse from 'html-react-parser';
import { PropsWithChildren } from 'react';

import ZipForm from '~components/ZipCodeForm/ZipCodeForm';

import SpeakWithAgent from '../child-blocks/SpeakWithAgent';

interface IProps {
    stateName?: string | undefined;
    planYear?: string | undefined;
    zipFormHeading?: string | undefined;
    zipFormMainCtaCopy?: string | undefined;
    zipFormSecondaryCtaCopy?: string | undefined;
    zipFormQaValue?: string;
}

const ZipWithPhoneNumberSimplified = ({
    stateName = 'your state',
    planYear = '',
    zipFormHeading = '',
    zipFormMainCtaCopy = '',
    zipFormSecondaryCtaCopy = '',
    zipFormQaValue = '',
}: PropsWithChildren<IProps>) => {
    const heading =
        zipFormHeading || `See ${planYear} Medicare Advantage plans in&nbsp;<b>${stateName}</b>`;

    const toHtml = (p: string) => {
        return parse(p);
    };

    return (
        <section className="hero-paid-search-simplified-style">
            <h2 className="text-center lg:text-start">{toHtml(heading)}</h2>
            <div className="rounded-lg flex justify-center">
                <div className="max-w-screen-xs md:max-w-screen-xl w-full">
                    <div>
                        <ZipForm
                            buttonTitle="See plans in my area"
                            buttonTitleMobile="See plans"
                            buttonWaLink="Hero Paid Search: Zip with Phone Number Simplified: Compare Plan"
                            qaValue="Hero Zip with Phone Number"
                            opts={{
                                btnStyle: 'primary',
                                useWideLayout: true,
                                isVerticalOnTablet: false,
                            }}
                        />
                    </div>

                    <div className="hidden md:block mt-6 md:mt-0">
                        <div className="grid grid-cols-12">
                            <div className="col-span-12">
                                <SpeakWithAgent
                                    headingCopy="Or speak with an eHealth licensed insurance agent"
                                    fromComponentName="Hero Paid Seach: Zip with Phone Number Simplified"
                                    textAlign="left"
                                    phoneNumberTextStyle="text-primary-dark"
                                    ttyFontWeight="font-extralight"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ZipWithPhoneNumberSimplified;
